export default __webpack_public_path__ + "assets/cfecae5bcd1fde5adf648949a6518e4a.png";